import { useAppSelector } from '../../../redux/hooks';

const useNewVirtualHumanConfig = () => {
  const { interviewInfo } = useAppSelector((state) => state.interview);
  const { interviewerModeConfig } = interviewInfo || {};
  return interviewerModeConfig;
};

export default useNewVirtualHumanConfig;
